import { render, staticRenderFns } from "./PipelineMenuItemPosition.vue?vue&type=template&id=47ddeecd&scoped=true&"
import script from "./PipelineMenuItemPosition.vue?vue&type=script&lang=ts&"
export * from "./PipelineMenuItemPosition.vue?vue&type=script&lang=ts&"
import style0 from "./PipelineMenuItemPosition.vue?vue&type=style&index=0&id=47ddeecd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ddeecd",
  null
  
)

export default component.exports